const SUBSCRIPTION_STATUS = {
    TRANSFERRED: {
        CODE: 4,
        DESCRIPTION: 'Transferido'
    }
}
export default { SUBSCRIPTION_STATUS }

